import { render } from "./TreeFolder.vue?vue&type=template&id=1374c640&scoped=true"
import script from "./TreeFolder.js?vue&type=script&lang=js"
export * from "./TreeFolder.js?vue&type=script&lang=js"

import "./TreeFolder.vue?vue&type=style&index=0&id=1374c640&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1374c640"]])

export default __exports__